export const notImplemented = () => {
  throw Error('Not implemented');
};
